import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  messageWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-end',
    padding: theme.spacing(1),
  },
  notMyMessage: {
    flexDirection: 'row-reverse',
  },

  messageContainer: {
    width: 'auto',
    maxWidth: '70%',
    padding: theme.spacing(1),
    borderRadius: '4px',
    backgroundColor: theme.palette.background.default,
    wordBreak: 'break-all',
  },
  filesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));
